<div class="lvi-content">
    <div class="avatar" [innerHTML]="icone"></div>
    <div class="lvi-body">
        <div class="title">
            <a [routerLink]="" (click)="extraOptions.parent.selectParamConnexion(data)">{{ data.champ?.libelle }}</a>
        </div>
    </div>
</div>
